// src/pages/Dashboard.js
import React, { useState } from 'react';
import { 
  Box,
} from '@mui/material';
import { DashboardProvider } from '../../context/DashboardContext';
import DateRangeFilter from '../../components/common/DateRangeFilter';
import dayjs from 'dayjs';

const defaultDateRange = {
  filter: { id: 'Today', label: 'Today' },
  currentStart: dayjs().startOf('day'),
  currentEnd: dayjs().endOf('day'),
  compareStart: null,
  compareEnd: null,
};

const Dashboard = () => {
  const [dateRangeState, setDateRangeState] = useState(defaultDateRange);
  // Handler for DateRangeFilter
  const handleDateRangeChange = (rangeObj) => {
    setDateRangeState(rangeObj);
  };

  return (
    <DashboardProvider>
      <Box 
        sx={{ 
          flexGrow: 1,
          py: 3,
          px: { xs: 2, sm: 3 },
          backgroundColor: 'background.default'
        }}
      >
      </Box>
    </DashboardProvider>
  );
};

export default Dashboard;